import ReactDOM from "react-dom/client";
import App from "./App";
//TODO: tasarım tamamlanması ile style.css kaldırılacak
import "./assets/styles/style.css";
import "./styles/global.css";
import "./i18n";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <App />
  </>
);
